"use client"

import React, { useContext } from "react"
import mainContext from "../../contexts/mainContext"
import { getSeekersListing } from "../../Controllers/userManagment/customer"
import { deleteUser } from "../../Controllers/userManagment/common"

import UserCard from "./UserCard"
import Pagination from "@mui/material/Pagination"
import SearhcBar from "./SearhcBar"
import { __constants, __snackBarText, __snackBarSeverity } from "../../constants"
import LoopIcon from "@mui/icons-material/Loop"

const SeekersListing = () => {
  const { setSnackBar, setProfileNavTitle, nth, months, loginUserDetails, setPageload, pageload } =
    useContext(mainContext)
  const [totalCount, setTotalCount] = React.useState(1)
  const [seekers, setSeekers] = React.useState([])
  const [currentPage, setCurrentPage] = React.useState(1)
  const [filterState, setFilterState] = React.useState({})
  const callSnackBar = (msg, type) => {
    setSnackBar({
      status: true,
      text: msg,
      severity: __snackBarSeverity[type],
    })
  }

  const getSeekers = async (page, filterApply = true, id = "") => {
    let param = null
    if (filterApply) {
      param = { page: page, id, ...filterState }
      if (loginUserDetails.role === "Concierge") param.conceirgeId = loginUserDetails._id
    } else {
      param = { page: page, id }
      if (loginUserDetails.role === "Concierge") param.conceirgeId = loginUserDetails._id
    }
    setPageload(true)
    setSeekers([])
    const res = await getSeekersListing(param)
    setPageload(false)
    if (res && res.status === 500) {
      return callSnackBar(__snackBarText.internalServerError, "error")
    }
    if (res.data.status !== 200) {
      return callSnackBar(res.data.errors[0].message, "error")
    }
    setSeekers(res.data.data.seekers)
    setTotalCount(res.data.data.total)
  }

  const handlePaginationClick = (e, page) => {
    setCurrentPage(page)
    getSeekers(page)
  }

  React.useEffect(() => {
    try {
      const url = new URLSearchParams(window.location.search)
      if (url.get("id")) {
        getSeekers(1, true, url.get("id"))
      } else {
        getSeekers(1)
      }
    } catch (error) {
      getSeekers(1)
    }
    setProfileNavTitle("CUSTOMERS")
    // eslint-disable-next-line
  }, [])

  /* Handle update profile */
  const handleUpdate = (data, index) => {
    const temp = [...seekers]
    temp[index] = data
    setSeekers(temp)
  }

  /* Handle delete user */
  const handleDelete = async (userId) => {
    setPageload(true)
    const res = await deleteUser(userId)
    setPageload(false)

    if (res && res.status === 500) {
      return callSnackBar(__snackBarText.internalServerError, "error")
    }
    if (res.data.status !== 200) {
      return callSnackBar(res.data.errors[0].message, "error")
    }

    callSnackBar("User deleted successfully", "success")
    // Remove the deleted user from the list
    setSeekers((prev) => prev.filter((seeker) => seeker._id !== userId))
    // Update total count
    setTotalCount((prev) => prev - 1)
  }

  return (
    <>
      <SearhcBar
        filterState={filterState}
        setFilterState={setFilterState}
        callFunction={getSeekers}
        userType="seeker"
      />
      <div className="component_body scrollbar">
        <div className="list_header customer_list_grid">
          <div>
            <div>Status</div>
          </div>
          <div>Username</div>
          <div>Email</div>
          <div>Phone</div>
          <div>City</div>
          <div style={{ textAlign: "right" }}>Registered</div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <LoopIcon
              onClick={() => {
                getSeekers(currentPage)
              }}
              className="pointer"
            />
          </div>
        </div>

        <div>
          {seekers.map((e, index) => {
            const createdAt = new Date(e.createdAt)
            return (
              <UserCard
                key={e._id}
                userId={e._id}
                openCanvasOf="seeker"
                status={e.status}
                name={e.firstName || e.lastName ? `${e.firstName || ""} ${e.lastName || ""}`.trim() : "---"}
                city={e.city || "---"}
                email={e.email || "---"}
                mobile={e.mobileNo ? `${e.dialCode ? `${e.dialCode} ` : ""}${e.mobileNo}` : "---"}
                userInfo={e}
                onUpdate={(data) => handleUpdate(data, index)}
                onDelete={handleDelete}
                added={`${createdAt.getDate()}${nth(createdAt.getDate())} ${months[createdAt.getMonth()].slice(0, 3)} ${createdAt.getFullYear()}`}
              />
            )
          })}
        </div>
        {seekers.length === 0 && !pageload && (
          <div className="no-record">
            <span>No Record Found</span>
          </div>
        )}
      </div>
      {/* {
                seekers.length > 0 && */}
      <>
        <Pagination
          count={Math.ceil(totalCount / __constants.listingLimit)}
          color="primary"
          shape="rounded"
          onChange={(e, page) => {
            handlePaginationClick(e, page)
          }}
        />
        <br />
      </>

      {/* } */}
    </>
  )
}

export default SeekersListing